import ApiService from "./api.service";

class VotingService extends ApiService {
    getBasicVotingModesData() {
        return this.get(`api/voting/modes`)
    }
    getVotingData(id, pid, sid) {
        return this.get(`api/voting/sessions/${sid}/points/${pid}/votings/${id}`)
    }
    getVotingMetadata(id, pid, sid) {
        return this.get(`api/voting/sessions/${sid}/points/${pid}/votings/${id}/metadata`)
    }
    removeVoting(id, pid) {
        return this.delete(`api/voting/points/${pid}/votings/${id}`)
    }
    addOrUpdateVoting(pid, data) {
        if (!data.id) {
            return this.post(`api/voting/points/${pid}/votings`, data)
        }
        return this.put(`api/voting/points/${pid}/votings/${data.id}`, data)
    }
    addVotingToMultiplePoints(sid, data) {
        return this.post(`api/voting/sessions/${sid}/votings/multiple-points`, data)
    }
    getVotingUsersList(sid, gid) {
        return this.get(`api/voting/sessions/${sid}/votings/${gid}/users`)
    }
    getUsersForVotingExcluded(gid, sid) {
        return this.get(`api/voting/sessions/${sid}/votings/${gid}/excluded-users`)
    }
    excludeUserFromVoting(gid, sid, data) {
        return this.put(`api/voting/sessions/${sid}/votings/${gid}/excluded-users`, data)
    }
    getVotingsPossibleAnswers(gid) {
        return this.get(`api/voting/votings/${gid}/answers`)
    }
    getVotingsSummaryResults(gid, mode, isPublic, type) {
        return this.get(`api/voting/votings/${gid}/summary?mode=${mode}&isPublic=${isPublic}&type=${type}`)
    }
    getVotingSummaryToWordFile(data) {
        return this.post(`Voting/getVotingSummaryToWordFile`, data, { responseType: "arraybuffer" })
    }
    getVotingInteractiveDataForResults(sessionId, pointId, votingId) {
        return this.get(`api/voting/sessions/${sessionId}/points/${pointId}/votings/${votingId}/result-data`)
    }
    getVotingInteractiveData(sessionId, pointId, votingId) {
        return this.get(`api/voting/sessions/${sessionId}/points/${pointId}/votings/${votingId}/interactive`)
    }
    reorderVotings(pointId, votings) {
        return this.put(`api/voting/points/${pointId}/votings/order`, votings)
    }
    sendVoteForUserByAdmin(data, gid) {
        return this.post(`api/voting/votings/${gid}/admin-votes`, data)
    }
    getBlockVotingsResults(pointId, sessionId) {
        return this.get(`api/voting/sessions/${sessionId}/points/${pointId}/block-results`)
    }
    addMultipleVotings(pid, data) {
        return this.post(`api/voting/points/${pid}/votings/batch`, data)
    }
    editVotingName(pid, data) {
        return this.patch(`api/voting/points/${pid}/votings/${data.id}/name`, data)
    }
    dragVotingToPoint(sid, data) {
        return this.patch(`api/voting/sessions/${sid}/votings/${data.votingId}/point`, data)
    }
    exportVotingResultsToOtherSession(sid, data) {
        return this.post(`api/voting/sessions/${sid}/voting-exports`, data)
    }
    removeExportingVoting(sid, data) {
        const exportId = data && (data.id || data.Id);
        return this.delete(`api/voting/sessions/${sid}/voting-exports/${exportId}`, data)
    }
    getExportVotingDefaultName(sid, pid, gid) {
        return this.get(`api/voting/sessions/${sid}/points/${pid}/votings/${gid}/export-default-name`)
    }
    getVotingReportBySession(sessionId) {
        return this.get(`Voting/getComputedVotingReportBySession/${sessionId}`, { responseType: "arraybuffer" });
    }
    getAllVotingsInSession(sid, data) {
        return this.post(`api/voting/sessions/${sid}/votings/search`, data)
    }
    getVotingCanEdit(id, pid, sid) {
        return this.get(`api/voting/sessions/${sid}/points/${pid}/votings/${id}/can-edit`)
    }
}

export default new VotingService();
